import { all } from 'redux-saga/effects';
import publicHolidays from './public-holiday';

export const publicHolidaySaga = function* root() {
  yield all([publicHolidays()]);
};
